import React, { useEffect, useState } from 'react';
import { Dialog, Button, TextField, MenuItem, Select, InputLabel, FormControl } from '@mui/material';
import { axiosGetCall, axiosPostCall } from 'src/services/apisCall';
import { renderErrorMessage, renderSuccessMessage } from 'src/lib/toastMessage';
import { ConfirmDialog } from 'src/components/custom-dialog';
const AddLogger = ({ open, onClose, addLoad, setAddLoad }) => {
  const [scriptName, setScriptName] = useState('');
  const [env, setEnv] = useState('');
  const [selectOptions, setSelectOptions] = useState([]);
  const [logLevel, setLogLevel] = useState('');

  const fetchDropdownOptions = async () => {
    try {
      const data = await axiosGetCall('fetchLoggerEnv');
      setSelectOptions(data || []);
    } catch (error) {
      renderErrorMessage(error?.message);
    }
  };

  useEffect(() => {
    if (open) {
      fetchDropdownOptions();
    }
  }, [open]);

  const handleSave = async () => {
    const payload = {
      env,
      scriptName,
      logLevel,
    };

    try {
      if (env && scriptName && logLevel) {
        const response = await axiosPostCall('changeLogLevel', payload);
        if (response === 'OK') {
          renderSuccessMessage('New Script Added successfully');
        }
        setEnv('');
        setScriptName('');
        setLogLevel('');
        setAddLoad(!addLoad);
        onClose();
      } else {
        renderErrorMessage('Please fill all the required fields.');
      }
    } catch (error) {
      renderErrorMessage('Something went wrong!');
    }
  };
  const content = () => {
    return (
      <>
        <FormControl fullWidth sx={{ mt: 1 }}>
          <InputLabel id="env-label">Select Option</InputLabel>
          <Select
            labelId="env-label"
            id="env-select"
            value={env}
            label="Select Option"
            onChange={(e) => setEnv(e.target.value)}
          >
            {selectOptions.map((option, index) => (
              <MenuItem key={index} value={option.value || option}>
                {option.label || option}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <TextField
          label="Script Name"
          variant="outlined"
          value={scriptName}
          onChange={(e) => setScriptName(e.target.value)}
          fullWidth
          sx={{ mt: 2 }}
        />

        <FormControl fullWidth sx={{ mt: 2 }}>
          <InputLabel id="level-label">Level</InputLabel>
          <Select
            labelId="level-label"
            id="level-select"
            label="Level"
            value={logLevel}
            onChange={(e) => setLogLevel(e.target.value)}
          >
            <MenuItem value="20">Info</MenuItem>
            <MenuItem value="30">Debug</MenuItem>
          </Select>
        </FormControl>
      </>
    );
  };

  return (
    <ConfirmDialog
      title="Add Logger"
      content={content()}
      action={
        <Button variant="contained" onClick={handleSave}>
          Save
        </Button>
      }
      open={open}
      onClose={onClose}
    />
  );
};

export default AddLogger;
